import { environment } from '@/environments/environment'
export default [
  { name: 'filterDeliveryByTag', url: `${environment.apiPlatform}/v1/find-deliveries`, method: 'get'},
  { name: 'filterExportDeliveriesByTag', url: `${environment.beijingApiUrl}/get_report_by_tag`, method: 'post'}
]